module.exports = __webpack_public_path__ + "static/media/3 04 Tulleord Modil er feil.1aac2fa7.mp3";